// Map paths to step numbers and header titles.
// 4-step model per the v27 onboarding design: Passport owns account (1), keys (2) and profile (3)
// and shows its own stepper; the app's header shows its one step, Experience (4), plus the two
// Passport-less pages that still have a title.
export const pathToStepConfig: Record<string, { step: number; title: string }> = {
  '/onboarding/join': { step: 1, title: 'Create account' },
  '/onboarding/profile': { step: 3, title: 'Profile' },
  '/onboarding/tags': { step: 4, title: 'Experience' },
  '/onboarding/follow': { step: 4, title: 'Experience' },
  '/logout': { step: 1, title: 'Signed out' },
  '/sign-in': { step: 1, title: 'Sign in' },
};
